import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/_service/report.service';
import { AlertifyService } from 'src/app/_service/alertify.service';

@Component({
  selector: 'company-report',
  templateUrl: './company-report.component.html',
  styleUrls: ['./company-report.component.css']
})
export class CompanyReportComponent implements OnInit {
  title: string;
  companyFields: any;
  selectAll: any;
  constructor(
    private reportService: ReportService,
    private alertify: AlertifyService
  ) {}
  
  report;
  checkAll = false;

  loading = false;
  isLoading = false;

  companyName;
  companyNameChecked = false;

  url;
  urlChecked = false; //

  sdsURL; //
  sdsURLChecked = false;

  effectiveContactMethod;
  effectiveContactMethodChecked = false;

  contactLocation; //
  contactLocationChecked = false;

  // contactEmail; //
  // contactEmailChecked = false;

  contactDetails;
  contactDetailsChecked = false;

  // contactUrl;
  // contactUrlChecked = false;

  // faxNumber;
  // faxNumberChecked = false;
  
  alternateCompanyNames;
  alternateCompanyNamesChecked = false;

  companyNotes;
  companyNotesChecked = false;

  // phoneNumber;
  // phoneNumberChecked = false;

  mostRecentRequestDate;
  mostRecentRequestDateChecked = false;

  selectionRequired: any = {};

  ngOnInit() {
  }


  onCompanyNameChecked() {
    this.companyName = '';
    if (this.companyNameChecked) {
      this.companyName = 'CompanyName';
    }
  }

  onUrlChecked() {
    this.url = '';
    if (this.urlChecked) {
      this.url = 'URL';
    }
  }

  onSDSURLChecked() {
    this.sdsURL = '';
    if (this.sdsURLChecked) {
      this.sdsURL = 'MSDSURL';
    }
  }

  onEffectiveContactMethodChecked() {
    this.effectiveContactMethod = '';
    if (this.effectiveContactMethodChecked) {
      this.effectiveContactMethod = 'EffectiveContactMethod';
    }
  }

  onContactLocationChecked() {
    this.contactLocation = '';
    if (this.contactLocationChecked) {
      this.contactLocation = 'ContactLocation';
    }
  }

  // onContactEmailChecked() {
  //   this.contactEmail = '';
  //   if (this.contactEmailChecked) {
  //     this.contactEmail = 'EmailAddress';
  //   }
  // }

  // onContactURLChecked() {
  //   this.contactUrl = '';
  //   if (this.contactUrlChecked) {
  //     this.contactUrl = 'MSDSRequestFormUrl';
  //   }
  // }

  // onPhoneNumberChecked() {
  //   this.phoneNumber = '';
  //   if (this.phoneNumberChecked) {
  //     this.phoneNumber = 'PhoneNumber';
  //   }
  // }

  onContactDetailsChecked() {
    this.contactDetails = '';
    if (this.contactDetailsChecked) {
      this.contactDetails = 'ContactDetails';
    }
  }

  // onContactFaxNumberChecked() {
  //   this.faxNumber = '';
  //   if (this.faxNumberChecked) {
  //     this.faxNumber = 'FaxNumber';
  //   }
  // }

  onAlternateCompanyNamesChecked() {
    this.alternateCompanyNames = '';
    if (this.alternateCompanyNamesChecked) {
      this.alternateCompanyNames = 'AlternateCompanyNames';
    }
  }

  onCompanyNotesChecked() {
    this.companyNotes = '';
    if (this.companyNotesChecked) {
      this.companyNotes = 'CompanyNotes';
    }
  }

  onMostRecentRequestDate() {
    this.mostRecentRequestDate = '';
    if (this.mostRecentRequestDateChecked) {
      this.mostRecentRequestDate = 'MostRecentRequestDate';
    }
  }

  onSelectAllClick(event) {
    if (event.checked) {
      this.companyNameChecked = true;
      if (this.companyNameChecked) {
        this.onCompanyNameChecked();
      }
      this.urlChecked = true;
      if (this.urlChecked) {
        this.onUrlChecked();
      }
      this.sdsURLChecked = true;
      if (this.sdsURLChecked) {
        this.onSDSURLChecked();
      }
      this.effectiveContactMethodChecked = true;
      if (this.effectiveContactMethodChecked) {
        this.onEffectiveContactMethodChecked();
      }
      this.contactLocationChecked = true;
      if (this.contactLocationChecked) {
        this.onContactLocationChecked();
      }
      this.contactDetailsChecked = true;
      if (this.contactDetailsChecked) {
        this.onContactDetailsChecked();
      }
      // this.contactEmailChecked = true;
      // if (this.contactEmailChecked) {
      //   this.onContactEmailChecked();
      // }
      // this.contactUrlChecked = true;;
      // if (this.contactUrlChecked) {
      //   this.onContactURLChecked();
      // }
      // this.phoneNumberChecked = true;
      // if (this.phoneNumberChecked) {
      //   this.onPhoneNumberChecked();
      // }
      // this.faxNumberChecked = true;
      // if (this.faxNumberChecked) {
      //   this.onContactFaxNumberChecked();
      // }
      this.alternateCompanyNamesChecked = true;
      if (this.alternateCompanyNamesChecked) {
        this.onAlternateCompanyNamesChecked();
      }
      this.companyNotesChecked = true;
      if (this.companyNotesChecked) {
        this.onCompanyNotesChecked();
      }
      this.mostRecentRequestDateChecked = true;
      if (this.mostRecentRequestDateChecked) {
        this.onMostRecentRequestDate();
      }
    } else {
      this.companyNameChecked = false;
      this.companyName = '';
      this.urlChecked = false;
      this.url = '';
      this.sdsURLChecked = false;
      this.sdsURL = '';
      this.effectiveContactMethodChecked = false;
      this.effectiveContactMethod = '';
      this.contactLocationChecked = false;
      this.contactLocation = '';
      this.contactDetailsChecked = false;
      this.contactDetails = '';
      // this.contactEmailChecked = false;
      // this.contactEmail = '';
      // this.contactUrlChecked = false;
      // this.contactUrl = '';
      // this.phoneNumberChecked = false;
      // this.phoneNumber = '';
      // this.faxNumberChecked = false;
      // this.faxNumber = '';
      this.alternateCompanyNamesChecked = false;
      this.alternateCompanyNames = '';
      this.companyNotesChecked = false;
      this.companyNotes = '';
      this.mostRecentRequestDateChecked = false;
      this.mostRecentRequestDate = '';
    }
  }

  generateCompanyExcelReport() {
    const params = new URLSearchParams();
    if (this.companyName !== undefined && this.companyName.length !== 0) {
      params.append('selection', this.companyName);
    }
    if (this.url !== undefined && this.url.length !== 0) {
      params.append('selection', this.url);
    }
    if (this.sdsURL !== undefined && this.sdsURL.length !== 0) {
      params.append('selection', this.sdsURL);
    }
    if (this.effectiveContactMethod !== undefined && this.effectiveContactMethod.length !== 0) {
      params.append('selection', this.effectiveContactMethod);
    }
    if (this.contactLocation !== undefined && this.contactLocation.length !== 0) {
      params.append('selection', this.contactLocation);
    }
    // if (this.contactEmail !== undefined && this.contactEmail.length !== 0) {
    //   params.append('selection', this.contactEmail);
    // }
    if (this.contactDetails !== undefined && this.contactDetails.length !== 0) {
      params.append('selection', this.contactDetails);
    }
    // if (this.contactUrl !== undefined && this.contactUrl.length !== 0) {
    //   params.append('selection', this.contactUrl);
    // }
    // if (this.faxNumber !== undefined && this.faxNumber.length !== 0) {
    //   params.append('selection', this.faxNumber);
    // }
    if (this.alternateCompanyNames !== undefined && this.alternateCompanyNames.length !== 0) {
      params.append('selection', this.alternateCompanyNames);
    }
    if (this.companyNotes !== undefined && this.companyNotes.length !== 0) {
      params.append('selection', this.companyNotes);
    }
    // if (this.phoneNumber !== undefined && this.phoneNumber.length !== 0) {
    //   params.append('selection', this.phoneNumber);
    // }

    if (this.mostRecentRequestDate !== undefined && this.mostRecentRequestDate.length !== 0) {
      params.append('selection', this.mostRecentRequestDate);
    }

    this.isLoading = true;
    this.loading = true;

    this.reportService.generateManufacturerReport(params).subscribe(
      blob => {
        this.report = blob.body;
        this.selectionRequired = blob.headers.get('selectionrequired');
        if (this.selectionRequired) {
          this.loading = false;
          this.isLoading = false;
          this.alertify.message(this.selectionRequired);
          } else {
            if (blob) {
              const link = document.createElement('a');
              if (window.navigator &&
                window.navigator.msSaveOrOpenBlob) { // for IE
                window.navigator.msSaveOrOpenBlob(blob.body, 'Company' + `.xlsx`);
                this.loading = false;
                this.alertify.message('Company report generation is complete');
            } else {
              link.href = window.URL.createObjectURL(blob.body);
              link.download = 'Company';
              link.click();
              this.loading = false;
              this.alertify.message('Company report generation is complete');
            }
            }
          }
      },
      error => {
        this.alertify.error('Company Report Generation failed, please try again!');
        this.loading = false;
        this.isLoading = false;
      }
    );
  }
}